export const codeEditorValue = (value: unknown): string => {
    if (value == null || value === "null") return "";
    return typeof value === "string" ? value : JSON.stringify(value, null, 2);
};
export const normalizeCodePayload = (value: unknown): unknown => value === "null" ? null : value;
export const recordDisplayName = (record: Record<string, unknown>): string => {
    for (const key of ["name", "label", "title", "number_ref", "id"]) {
        const value = record[key];
        if (value != null && String(value).trim()) return String(value);
    }
    return "";
};
export const isPermissionError = (error: unknown): boolean => {
    const candidate = error as any;
    return candidate?.response?.status === 403 || candidate?.response?.data?.error?.code === "FORBIDDEN";
};

const blankToNull = (value: unknown) => (value === undefined || value === "" ? null : value);
const sameValue = (left: unknown, right: unknown): boolean => {
    const a = blankToNull(left);
    const b = blankToNull(right);
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object" || a === null || b === null) return false;
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    const keys = new Set([...Object.keys(a as object), ...Object.keys(b as object)]);
    return Array.from(keys).every((key) => sameValue((a as Record<string, unknown>)[key], (b as Record<string, unknown>)[key]));
};
/**
 * True only when every current form value equals its initial value (undefined/""/null are equivalent).
 * Deliberately NOT based on react-hook-form's `formState.isDirty`: reading it inside an async callback is stale
 * (unsubscribed), which made real edits look like "no changes" and silently dropped them.
 */
export const formValuesUnchanged = (current: unknown, initial: unknown): boolean => sameValue(current ?? {}, initial ?? {});
